"use client";

import { useEffect } from "react";
import { readMarketingCampaign } from "@/lib/signupAttribution";

/** Store an allowlisted campaign in the existing first-party session record. */
export function FeatureCampaignCapture({ campaign }: { campaign?: string }) {
  useEffect(() => { readMarketingCampaign(); }, [campaign]);
  return null;
}
